"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var time_1 = require("utils/time");
var s = require("./index.scss");
var CountDown = (function (_super) {
    __extends(CountDown, _super);
    function CountDown(props) {
        var _this = _super.call(this, props) || this;
        _this.setCountDown = function () {
            var sec = _this.props.sec;
            var t = parseInt(sec, 10);
            var interval = setInterval(function () {
                if (t > -1) {
                    t -= 1;
                    _this.setState({
                        countDown: time_1.secToTime(t)
                    });
                }
                else {
                    clearInterval(interval);
                }
            }, 1000);
        };
        _this.state = {
            countDown: time_1.secToTime(parseInt(_this.props.sec, 10))
        };
        return _this;
    }
    CountDown.prototype.componentDidMount = function () {
        this.setCountDown();
    };
    CountDown.prototype.render = function () {
        var countDown = this.state.countDown;
        return (React.createElement("div", { className: s.countDown },
            "Remaining ",
            React.createElement("span", null, countDown)));
    };
    return CountDown;
}(React.Component));
exports.default = CountDown;
